import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { KontniPlan } from './kontni-plan';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-kontni-plan-update',
  templateUrl: './kontni-plan-update.component.html'
})
export class KontniPlanUpdateComponent extends BaseUpdateComponent<KontniPlan> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService,translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Konto", Validators.required, 'required', 'KONTNIPLAN.KONTO.VALIDATION.REQUIRED');
    this.addValidatorToFc("Konto", Validators.maxLength(8), 'maxlength', 'KONTNIPLAN.KONTO.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'KONTNIPLAN.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'KONTNIPLAN.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("NazivEn", Validators.maxLength(100), 'maxlength', 'KONTNIPLAN.NAZIVEN.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("VrstaKontnogPlanaID", Validators.required, 'required', 'KONTNIPLAN.VRSTAKONTNOGPLANAID.VALIDATION.REQUIRED');
  }

}
